// extracted by mini-css-extract-plugin
module.exports = {"spinner-container":"PageLoadingFallback_spinner-container__PzIsS","spinner-relative":"PageLoadingFallback_spinner-relative__22jIj"};